<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >

    <template v-slot:activator="{ on }">
      <v-btn
          v-if="mode === 'create'"
          color="primary"
          v-on="on">
        <v-icon>mdi-plus</v-icon>
        Adicionar Funcionário
      </v-btn>
      <v-btn
          v-else
          icon
          v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle()}} Funcionário
      </v-card-title>

      <v-card-text>
        <v-form
            ref="form"
            v-model="valid">

          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="cpf"
                    :rules="requiredRules"
                    label="CPF"
                    required
                ></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs6>
                <v-text-field
                    v-model="email"
                    :rules="requiredRules"
                    label="E-mail"
                    required
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                    v-model="registration_number"
                    label="Matrícula"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs7>
                <v-layout left align-center>
                  <v-checkbox
                      v-model="can_access_web"
                      label="Permite Acessar Web"
                  ></v-checkbox>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2"
                          v-bind="attrs"
                          v-on="on"
                      >mdi-information</v-icon>
                    </template>
                    <span>Permite o usuário acessar o Portal Licenciamento Admin pelo site</span>
                </v-tooltip>
                </v-layout>
              </v-flex>
              <v-flex xs5>
                <v-checkbox
                    v-model="enabled"
                    label="Ativo?"
                ></v-checkbox>

              </v-flex>
            </v-layout>
          </v-container>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-space-between>
          <v-btn
              :disabled="loading"
              flat
              @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import AdminService from '@/services/applications/configurations/AdminService';

  export default {
    name: 'CreateOrUpdate',
    props: ['admin', 'mode'],
    components: {},
    data() {
      return {
        id: '',
        name: '',
        cpf: '',
        email: '',
        registration_number: '',
        enabled: false,
        can_access_web: true,
        loading: false,
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        cpfRule: [
          v => !!v || 'Campo Obrigatório',
        ],

        dialog: false,
        valid: false,
      };
    },
    methods: {
      save() {
        const payload = {
          id: this.id,
          name: this.name,
          cpf: this.cpf.replace(/\D/g, ""),
          email: this.email,
          enabled: this.enabled,
          can_access_web: this.can_access_web,
          registration_number: this.registration_number,
        };
        AdminService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Funcionário ${ this.snackBarMode() } com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.dialog = false;
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      }
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          if (this.admin !== null) {
            this.id = this.admin.id;
            this.name = this.admin.name;
            this.cpf = this.admin.cpf;
            this.email = this.admin.email;
            this.enabled = this.admin.enabled;
            this.can_access_web = this.admin.can_access_web;
            this.registration_number = this.admin.registration_number;
          }
        } else {
          this.$refs.form.reset();
        }
      },
    }
  };
</script>

<style scoped lang="scss">
</style>
